import React from 'react';

const Takeout = () => {
    return (
        <div className="banner_2">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="banner_left">
                            <div className="section_header">
                                <h2 className="section_title">Safe food take out</h2>
                                <h6 className="section_sub_title">
                                    We are open for anu order Online
                                </h6>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                    tempor incididunt ut labore et dolore magna aliqua. Ut en ad
                                    minim veniam.
                                </p>
                            </div>
                            <div className="contact_info">
                                <div className="phone">
                                    <img src="images/phone2.png" alt="phone" />
                                    <div>
                                        <span>Call us to order online</span><br />+0888 . 1234 .
                                        5699
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="banner_right">
                            <img src="images/bg/banner_bg1.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Takeout;